import Input from './Input';
import Button from './Button';
import Select from './Select';
import AutocompleteInput from './AutoCompleteInput';

// eslint-disable-next-line import/prefer-default-export
export const Controls = {
  Input,
  Button,
  AutocompleteInput,
  Select,
};
